import TermsAndConditionsForm from './TermsAndConditionsForm';

export default TermsAndConditionsForm;
